import { Stack, useTheme } from '@mui/material';

import { ATSAutomationListTestIds } from 'data-testids/ATS';
import { useAutomation } from 'features/Automations/context/AutomationContext';
import { AutomationListCTAProps } from 'features/Automations/types';
import { SecondaryButton } from 'sharedComponents/Buttons';
import { secondaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';

export const AutomationListCTA: React.FC<AutomationListCTAProps> = () => {
  const theme = useTheme();
  const { onClose } = useAutomation();

  return (
    <Stack alignItems="flex-end" sx={{ pt: 3 }}>
      <SecondaryButton
        dataTestId={ATSAutomationListTestIds.CLOSE_BUTTON}
        onClick={() => onClose()}
        sx={{ ...secondaryButtonOverrideSx(theme) }}
      >
        Close
      </SecondaryButton>
    </Stack>
  );
};
